export enum Environment {
    prod= "prod",
    uat= "uat",
    local= "local"
}
